import React, { useEffect, useState } from "react";
import { Container, ProgressBar } from "react-bootstrap";
import Card from "../HOME/Card";
import { message, Rate } from "antd";
import Slider from "react-slick";
import FAQ from "../HOME/FAQ";
import { useParams } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../API/config";
import CompareCard from "./CompareCard";
import { useMediaQuery } from "react-responsive";

const ProdDesc = ({ product }: { product: any }) => {
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const { category } = useParams();
  const [ogData, setOgData] = useState<any[]>([]);
  const [reviews, setReviews] = useState<any[]>([]);
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const handleGetProd = async () => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      message.error("Login required!");
      return;
    }
    try {
      const res = await axios.get(`${API_URL}/api/products/${category}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // Check if the data has at least two products
      if (res.data && res.data.products.length > 1) {
        // Select two random products from the fetched data
        const randomIndexes: any = [];
        while (randomIndexes.length < 3) {
          const index = Math.floor(Math.random() * res.data.products.length);
          if (!randomIndexes.includes(index)) {
            randomIndexes.push(index);
          }
        }

        const randomProducts = isMobile
          ? [
              res.data.products[randomIndexes[0]],
              res.data.products[randomIndexes[1]],
            ]
          : [
              res.data.products[randomIndexes[0]],
              res.data.products[randomIndexes[1]],
              res.data.products[randomIndexes[2]],
            ];

        // Set the random products as the displayed items
        setOgData(randomProducts);
      } else {
        console.log("Not enough products to display.");
      }
      await getReviewByID(product._id);
    } catch (error) {
      console.log(error);
    }
  };

  const getReviewByID = async (id: any) => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      message.error("Login required!");
      return;
    }
    try {
      const res = await axios.get(`${API_URL}/api/review/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setReviews(res.data.reviews);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handleGetProd();
  }, []);

  return (
    <>
      <div style={{ overflowX: "hidden" }}>
        <section className="py-4">
          <Container>
            <div style={{ backgroundColor: "#F4F4F4" }} className="p-3">
              <h2 className="head-txt-1 text-start">
                <span>Detailed</span> Overview
              </h2>
              <p
                className="pt-3"
                style={{ textIndent: "2rem", fontWeight: 500 }}
              >
                {product?.detailsOverview?.overview}
              </p>
              <table className="decs-table">
                {product?.description?.screenSize && (
                  <tr>
                    <th>Display</th>
                    <td
                      style={{
                        backgroundColor: "#FFFFFF",
                        border: "1px solid #EBEBEB",
                      }}
                    >
                      {product?.description?.screenSize}
                    </td>
                  </tr>
                )}
                {product?.detailsOverview?.processorSpeedType && (
                  <tr>
                    <th>Processor speed & type </th>
                    <td
                      style={{
                        backgroundColor: "#FFFFFF",
                        border: "1px solid #EBEBEB",
                      }}
                    >
                      {product?.detailsOverview?.processorSpeedType}
                    </td>
                  </tr>
                )}
                {product?.description?.processor && (
                  <tr>
                    <th>Performance</th>
                    <td
                      style={{
                        backgroundColor: "#FFFFFF",
                        border: "1px solid #EBEBEB",
                      }}
                    >
                      {product?.description?.processor}
                    </td>
                  </tr>
                )}
                {product?.description?.camera && (
                  <tr>
                    <th>Camera System</th>
                    <td
                      style={{
                        backgroundColor: "#FFFFFF",
                        border: "1px solid #EBEBEB",
                      }}
                    >
                      <span>{product?.description?.camera}</span>
                    </td>
                  </tr>
                )}
                {product?.description?.battery && (
                  <tr>
                    <th>Battery capacity</th>
                    <td
                      style={{
                        backgroundColor: "#FFFFFF",
                        border: "1px solid #EBEBEB",
                      }}
                    >
                      {product?.description?.battery},
                      {product?.description?.batteryCellComposition} battery
                    </td>
                  </tr>
                )}
                {product?.description?.connectionTechnology && (
                  <tr>
                    <th>Connectivity</th>
                    <td
                      style={{
                        backgroundColor: "#FFFFFF",
                        border: "1px solid #EBEBEB",
                      }}
                    >
                      {product?.description?.connectionTechnology}
                    </td>
                  </tr>
                )}
                {product?.description?.os && (
                  <tr>
                    <th>Software and Features</th>
                    <td
                      style={{
                        backgroundColor: "#FFFFFF",
                        border: "1px solid #EBEBEB",
                      }}
                    >
                      {product?.description?.os}
                      {`${"," + product?.description?.specialFeature}` || ""}
                    </td>
                  </tr>
                )}
                {product?.detailsOverview?.dimensionAndWeight && (
                  <tr>
                    <th>Dimension & Weight</th>
                    <td
                      style={{
                        backgroundColor: "#FFFFFF",
                        border: "1px solid #EBEBEB",
                      }}
                    >
                      {product?.detailsOverview?.dimensionAndWeight}
                    </td>
                  </tr>
                )}
              </table>
            </div>
          </Container>
        </section>
        <section className="py-4">
          <Container>
            <h2 className="head-txt-1 text-start">
              <span>Smart</span> Prize Compare
            </h2>
            <div className="row">
              <div className="sm-hidevs col-lg-3 col-md-4">
                <div className="col-lg-3 col-md-0 col-sm-0 col-0 d-flex justify-content-center align-items-center">
                  <div>
                    <img className="img-fluid vs" src="/assets/vs.png" />
                  </div>
                </div>
              </div>
              <CompareCard product={ogData} />
            </div>
          </Container>
        </section>
        {reviews.length > 0 && (
          <section className="py-4">
            <Container>
              <h2 className="head-txt-1 text-start">
                <span>Top</span> Reviews
              </h2>
              <div className="row">
                <div className="slider-container">
                  <Slider {...settings}>
                    {reviews.map((val, i) => (
                      <div className="px-3">
                        <div className="review-slide">
                          <p>{val?.userName}</p>
                          <Rate
                            disabled
                            value={val.rating}
                            allowHalf
                            style={{ fontSize: "12px" }}
                          />
                          <p>{val.review}</p>
                        </div>
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>
            </Container>
          </section>
        )}
      </div>
      <FAQ />
      {/* <RecentSearch /> */}
    </>
  );
};

export default ProdDesc;
